import React from 'react';
import { noop } from './lib/utils/utils';
const AlertDlgContext = React.createContext({
	onOpenAlertDlg: noop,
	onCloseAlertDlg: noop,
	alertDlgOpen: false
});

export default AlertDlgContext;
